import { Component, OnInit, ViewChild, Input, OnDestroy, HostListener } from '@angular/core';
import { GoogleMapType } from '../../enums/google-map-enum';
import { HybridGoogleMapService } from '../../services/hybrid-google-map/hybrid-google-map.service';

@Component({
    selector: 'aa-hybrid-google-map',
    templateUrl: './hybrid-google-map.component.html',
    styleUrls: ['./hybrid-google-map.component.scss'],
    standalone: false
})
export class HybridGoogleMapComponent implements OnInit, OnDestroy {
  @ViewChild('hybridGoogleMap', { static: true }) googleMapElement: any;
  @Input() data: any;
  @Input() mapStyle: any = '';
  @Input() mapType: GoogleMapType;

  constructor(private hybridGoogleMapService: HybridGoogleMapService) {}

  ngOnInit() {
    this.hybridGoogleMapService.setupHybridGoogleMap(this.googleMapElement, this.mapType, this.data);
  }

  ngOnDestroy(): void {
    this.hybridGoogleMapService.removeGoogleMap(this.mapType);
  }

  getMapType() {
    return this.mapType;
  }

  getMapClass() {
    let classs: any = this.mapStyle;
    classs += this.mapType > 999 ? ' map-small' : '';
    classs += ` map-type-${this.mapType}`;

    return classs;
  }

  // for context menu
  onRightClick(event: MouseEvent) {
    const ContextMenu = document.getElementById('my-context-menu');
    if (ContextMenu) {
      ContextMenu.style.top = event.offsetY + 'px';
      ContextMenu.style.left = event.offsetX + 'px';
      ContextMenu.style.display = 'block';
    }
  }

  @HostListener('click', ['$event.target'])
  HideContextMenuGoogle(event) {
    const ContextMenu = document.getElementById('my-context-menu');
    if (ContextMenu) {
      ContextMenu.style.display = 'none';
    }
  }
}
